import { useState } from 'react';
import { KeyRound, X } from 'lucide-react';

export const PasswordChangeField = ({ value, onChange, testId }) => {
  const [editing, setEditing] = useState(false);
  if (!editing) return (
    <button type="button" onClick={() => setEditing(true)} data-testid={`${testId}-enable`}
      className="flex items-center justify-center gap-2 rounded-lg border border-white/10 px-3 py-1.5 text-xs text-white/60 hover:text-white transition-colors">
      <KeyRound className="w-4 h-4" /> تغيير كلمة المرور
    </button>
  );
  return (
    <div className="flex min-w-0 items-center gap-1">
      <input type="password" autoComplete="new-password" name={testId} value={value}
        onChange={event => onChange(event.target.value)} aria-label="كلمة المرور الجديدة"
        placeholder="كلمة المرور الجديدة" data-testid={`${testId}-input`}
        className="min-w-0 w-full bg-[#1a1a2e] border border-white/10 rounded-lg px-3 py-1.5 text-white text-sm focus:outline-none" />
      <button type="button" onClick={() => { onChange(''); setEditing(false); }}
        aria-label="إلغاء تغيير كلمة المرور" title="إلغاء تغيير كلمة المرور" data-testid={`${testId}-cancel`}
        className="shrink-0 p-1 text-white/50 hover:text-white transition-colors"><X className="w-4 h-4" /></button>
    </div>
  );
};